module.exports = __webpack_public_path__ + "img/oldman_unselected.d404a537.png";